var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "section-promo-code" },
    [
      _c("div", { staticClass: "pt-3" }, [
        !_vm.appliedPromoCode &&
        _vm.preBookingData && !_vm.preBookingData.package_type
          ? _c("div", [
              _c(
                "div",
                {
                  staticClass: "d-flex pointer-item",
                  attrs: { role: "button" },
                  on: {
                    click: function($event) {
                      return _vm.openMyPromoCodeModal()
                    }
                  }
                },
                [
                  _c("div", { staticClass: "flex-fill" }, [
                    _c("i", { staticClass: "fal fa-ticket text-orange fa-lg" }),
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t("message.booking.payment_step.promo_code")
                        ) +
                        "\n        "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "flex-fill text-right text-black-50" },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t(
                              "message.booking.payment_step.select_promo_code"
                            )
                          ) +
                          " "
                      ),
                      _c("i", { staticClass: "fal fa-angle-right" })
                    ]
                  )
                ]
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.appliedPromoCode
          ? _c("div", { staticClass: "p-0" }, [
              !_vm.appliedPromoCode.is_applied
                ? _c("i", {
                    staticClass: "fas fa-exclamation-triangle -status-alert"
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "no-style",
                  attrs: { href: "" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.displayPromoCodeDetailDialog()
                    }
                  }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("message.booking.summary.discount")) +
                      ": " +
                      _vm._s(_vm.appliedPromoCode.promo_code.code) +
                      " (" +
                      _vm._s(_vm.appliedPromoCode.discount) +
                      "%)\n      "
                  )
                ]
              ),
              _vm._v(" "),
              _vm.preBookingData &&
              !_vm.preBookingData.subscription_type_id &&
              !_vm.preBookingData.package_type &&
              _vm.appliedPromoCode.promo_code.code_type !== "new_prof"
                ? _c(
                    "a",
                    {
                      staticClass: "no-style",
                      attrs: { href: "" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.displayCancelPromoCodeDialog()
                        }
                      }
                    },
                    [_c("i", { staticClass: "fas fa-times" })]
                  )
                : _vm._e()
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.preCheckoutData
        ? _c("div", { staticClass: "wallet_credit mt-3" }, [
            _c("hr"),
            _vm._v(" "),
            _c("div", {}, [
              _c("div", { staticClass: "row no-gutters" }, [
                _c("div", { staticClass: "col-10" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("message.booking.summary.my_credits")) +
                      ": "
                  ),
                  _c("strong", [
                    _vm._v(
                      _vm._s(
                        _vm._f("currency")(_vm.preCheckoutData.total_credits)
                      )
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-2 text-right" },
                  [
                    _c("toggle-button", {
                      attrs: {
                        sync: true,
                        disabled: _vm.checkIsCreditAvailable(),
                        color: "#FFC107"
                      },
                      model: {
                        value: _vm.preCheckoutData.is_credit,
                        callback: function($$v) {
                          _vm.$set(_vm.preCheckoutData, "is_credit", $$v)
                        },
                        expression: "preCheckoutData.is_credit"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.appliedPromoCode &&
                _vm.appliedPromoCode.promo_code.is_credit_available === 0
                  ? _c(
                      "div",
                      { staticClass: "-status-alert text-remark py-2" },
                      [
                        _c("i", {
                          staticClass:
                            "fas fa-exclamation-triangle -status-alert"
                        }),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                "message.booking.checkout_step.cannot_use_coins_with_promo_code"
                              )
                            ) +
                            "\n        "
                        )
                      ]
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row no-gutters text-remark mt-2" }, [
                _c("div", { staticClass: "col-8" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t("message.booking.checkout_step.invite_friends")
                    )
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-4 text-right" }, [
                  _c(
                    "a",
                    {
                      staticClass: "text-primary-link",
                      attrs: { href: "#" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.openInviteFriendModal()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("message.home.see_detail_button")))]
                  )
                ])
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("invite-friend-modal", { ref: "inviteFriendModal" }),
      _vm._v(" "),
      _c("my-promo-code-modal", {
        ref: "myPromoCodeModal",
        attrs: { searchParams: _vm.searchParams },
        on: { onSelected: _vm.selectPromoCode }
      }),
      _vm._v(" "),
      _c("promo-code-detail-modal", { ref: "promoCodeDetailModal" }),
      _vm._v(" "),
      _c("snackbar", {
        ref: "snackbar",
        attrs: {
          baseSize: "100px",
          colors: {
            open: "#333",
            info: "#3DBD7D",
            error: "#FA7377",
            warn: "#FF6600"
          },
          holdTime: 2500,
          position: "bottom-center"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-57c89749", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57c89749","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/booking/components/PromoCode.vue
// module id = 1687
// module chunks = 0